import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReloadingService {
  private identifier: string = environment.StateIdentifier;
  private state = null;

  constructor() {
    this.loadState();
  }

  getState() {
    return this.state;
  }

  // will set state to null if the item does not exist in sessionStorage
  private loadState() {
    const stateString = sessionStorage.getItem(this.identifier);
    const state = JSON.parse(stateString);
    this.state = state;
  }
}
